module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('div', [_c('h1', {
    staticClass: "page-title f2 lh-copy pt3 mb2"
  }, [_vm._v("File New Claim")]), _vm._v(" "), _c('div', {
    staticClass: "losstype-heading cera-round-pro-medium"
  }, [_vm._v("\n      Type of Loss\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "losstype-desc"
  }, [_vm._v("\n      What happened to your device?\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "losstypes-btns"
  }, [_c('a', {
    staticClass: "losstypes-btn",
    attrs: {
      "href": _vm.userDevicesOnlyPhones
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "losstypes-txt-heading cera-round-pro-medium"
  }, [_vm._v("\n          Physical Damage\n        ")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "losstypes-ic"
  }, [_c('img', {
    attrs: {
      "src": "/static/icons/ic_physical_damage_generic.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "losstypes-txt-desc"
  }, [_vm._v("\n          Cracked screen, Physical /"), _c('br'), _vm._v("Liquid Damage\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "losstypes-btn",
    attrs: {
      "href": "/file-claim"
    }
  }, [_c('span', {
    staticClass: "losstypes-ic"
  }, [_c('img', {
    attrs: {
      "src": "/static/icons/ic_malfunction_generic.png"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "losstypes-txt-heading cera-round-pro-medium"
  }, [_vm._v("\n          Malfunction\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "losstypes-txt-desc"
  }, [_vm._v("\n          Screen flickering, Camera /"), _c('br'), _vm._v("Connectivity Issues\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "losstypes-btn",
    attrs: {
      "href": "/file-claim"
    }
  }, [_c('span', {
    staticClass: "losstypes-ic"
  }, [_c('img', {
    attrs: {
      "src": "/static/icons/ic_stolen_generic.png"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "losstypes-txt-heading cera-round-pro-medium"
  }, [_vm._v("\n          Stolen\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "losstypes-txt-desc"
  }, [_vm._v("\n          Theft / Robbery,"), _c('br'), _vm._v("Unrecoverable, Misplaced\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60d90e44","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LossType.vue
// module id = 1370
// module chunks = 0